export class Message {
    public id: number;
    public message: string;
    public type: string;
}


// WEBPACK FOOTER //
// ./src/models/message.ts